import { Component } from '@angular/core';
// import config.js
import config from '../../../../../config.js';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  applicationName = config.application_name;
  applicationVersion = config.application_version;
  copyrightYear = new Date().getFullYear();
}
